export class ObjectRecurser
{
    private object: any;
    private visited: WeakSet<object>;

    constructor(object: any)
    {
        this.object = object;
        this.visited = new WeakSet();
    }

    public recurse(onPropertyParsed: (property: IPropertyInfo) => any): void
    {
        this.privateRecurse(this.object, '/', onPropertyParsed);
    }

    private privateRecurse(object: any, path: string, onPropertyParsed: (property: IPropertyInfo) => any): void
    {
        const type = typeof object;
        if (object == null || type != 'object' || this.visited.has(object))
        {
            return;
        }

        this.visited.add(object);
        const propertyNames = Object.keys(object).sort((a, b) => a.localeCompare(b))

        for (const propertyName of propertyNames)
        {
            const propertyValue = object[propertyName];
            const propertyInfo: IPropertyInfo =
            {
                name: propertyName,
                value: propertyValue,
                type: typeof propertyValue,
                path: path + propertyName + '/',
            };
            const newValue = onPropertyParsed(propertyInfo);
            object[propertyName] = newValue;
            this.privateRecurse(newValue, propertyInfo.path, onPropertyParsed);
        }
    }
}

export interface IPropertyInfo
{
    name: string;
    value: unknown;
    type: Type;
    path: string;
}

export type Type = 'undefined' | 'object' | 'boolean' | 'number' | 'bigint' | 'string' | 'symbol' | 'function';
